import { render, staticRenderFns } from "./sort-product-by-category.vue?vue&type=template&id=aebd0788&"
import script from "./sort-product-by-category.vue?vue&type=script&lang=ts&"
export * from "./sort-product-by-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports